import { Injectable } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class SpinnerOverlayService {
  public isSpinnerShown = false;

  constructor() { }

  public shownSpinner() {
    this.isSpinnerShown = true;
  }

  public hideSpinner() {
    this.isSpinnerShown = false;
  }
}
